import React from 'react'

function Error() {
  return (
    <div>
        <h1> 404 NOT FOUND ! </h1>
    </div>
  )
}

export default Error
